import { jsonConverter } from '~/Scene/Tool/Json';
import { canvasInteraction } from '~/Services/Studio/Canvas/canvasInteraction';
import {
    _contentsManager, _system, _environment, _pipeline, _camera, _mouseCatcher, _pointofviewsManager
} from './studioScene';
import { checkVisibleSky } from '~/Services/Studio/Plugins/environment';
import { contextProject } from '~/Context/contextProject';
import { LOCAL_JSON } from '~/Services/Environment/devConfig';
import { addContent } from '~/Services/Studio/Contents/contentEditorManager';
import env from '../Environment/environment';

const loadFinish = (callback: (result: boolean) => void) => {
    // contentEventManager.showAnimation(true);
    // contentEventManager.showLights();
    _contentsManager.showContents();
    _contentsManager.showDecals(false);
    _mouseCatcher.start();
    canvasInteraction.setFreeMode();
    _environment.resetShadowGroundHeight();

    //! Dirty fix but otherwise sky is visible
    checkVisibleSky();
    _system.startRender();
    setTimeout(() => {
        callback(true);
    }, 200);
};

const startRender = (callback: (result: boolean) => void) => {
    // Set Camera before launchRender
    // It will avoid a flash when canvas become visible
    _system.updateSize();
    _system.launchRender(() => {
        loadFinish(callback);
    });
};

const addProjectContentEditor = (contents: any[]) => {
    contents.forEach((contentEditor) => {
        addContent(contentEditor.contentdata, contentEditor.typedata);
    });
};

const addCameraAndEnv = (project: any) => {
    _environment.checkOption(project.environment);
    _pipeline.checkOption(project.pipeline);
    _camera.setOption(project.camera);
};

const addPointOfViews = (povs: any[]) => {
    _pointofviewsManager.setPointofviews(povs);
};

export const createProject = (project: any, callback: (result: boolean) => void): void => {
    jsonConverter.clean(project);
    addCameraAndEnv(project);
    addProjectContentEditor(project.contents);
    addPointOfViews(project.pointofviews);
    _system.toolMaterial.materialList = project.materials;
    startRender(callback);
};

export const loadProjectJson = (projectId:string, callback: (json) => void): void => {
    if (env.saving) {
        contextProject.work(projectId, (project) => {
            if (!project) callback(false);
            else if (project.success !== undefined) callback(false);
            else {
                callback(project);
            }
        });
    } else {
        contextProject.projectFound(LOCAL_JSON);
        callback(LOCAL_JSON);
    }
};
